<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M15 28a1 1 0 102 0h-2zm1-24l.707-.707a1 1 0 00-1.414 0L16 4zm-8.707 7.293a1 1 0 101.414 1.414l-1.414-1.414zm16 1.414a1 1 0 001.414-1.414l-1.414 1.414zM17 28V4h-2v24h2zM15.293 3.293l-8 8 1.414 1.414 8-8-1.414-1.414zm0 1.414l8 8 1.414-1.414-8-8-1.414 1.414z"/></svg>